export function getInitials(fullName: string | null | undefined) {
    if (fullName == null || (fullName = fullName.trim()).length === 0) {
        return '?';
    }

    const names = fullName.split(' ');

    if (names.length > 1) {
        return names[0].substring(0, 1).toUpperCase() + names[names.length - 1].substring(0, 1).toUpperCase();
    }

    return fullName.substring(0, 2).toUpperCase();
}
